import type { LabelData } from "@/hooks/predictionMarket/usePredictionMarketLabels";

export const DEFAULT_LABELS_PREDICTION_MARKET: LabelData[] = ["人気", "New"];
